import { controlador, urlBase, urlPhp8 } from 'constants/urls';

const urlBaseMiddleware = `${urlPhp8}${controlador}api/v2/`;
const urlContratistas = `${urlBaseMiddleware}casuality/contratistas/`;

export const CASUALITY = {
  codProducto: 'CASUALTYCONTRATISTAS',

  urls: {
    datosCliente: "/casuality/informacion-cliente",
    datosGenerales: "/casuality/datos-generales",
    resumen: "/casuality/resumen",
    contratante: "/casuality/emision-contratante",
    asegurado: "/casuality/emision-asegurado",
    vigencia: "/casuality/emision-vigencia",
    pago: "/casuality/pago",
    finPago: "/casuality/finpago",
    recuperar: "/recuperar-cotizacion-casualitycontratistas",
    facturacion:'/facturacion/tipo-persona',
  },

  endpoints: {
    catalogo: `${urlBase}${controlador}api/v1/casuality/contratistas/catalogos`,
    guardarLead: `${urlBase}${controlador}api/v1/casuality/contratistas/guardar-lead`,
    catalogo2: `${urlBase}${controlador}api/v1/casuality/contratistas/catalogos-pantalla2`,
    guardarLead2: `${urlBase}${controlador}api/v1/casuality/contratistas/guardar-pantalla2`,
    guardarTracking: `${urlBase}${controlador}api/v1/leads/save-tracking`,
    resumen: `${urlBase}${controlador}api/v1/casuality/contratistas/resumen&XDEBUG_SESSION_START=name`,
    tarifacion: `${urlBase}${controlador}api/v1/casuality/contratistas/tarifacion`,
    recargo: `${urlBase}${controlador}api/v1/casuality/contratistas/recargos`,
    enviarCorreo: `${urlBase}${controlador}api/v1/casuality/contratistas/enviarcotizacion`,
    catalogoContratante: `${urlBase}${controlador}api/v1/emision/catalogos-contratante`,
    generarPrepoliza: `${urlBase}${controlador}api/v1/casuality/contratistas/generarprepoliza`,
    guardarContratante: `${urlBase}${controlador}api/v1/emision/guardado-contratante`,
    getUsuarioSuscriptor: `${urlBase}${controlador}api/v1/casuality/contratistas/getusuariosuscriptor`,
    asignacionSuscriptor: `${urlBase}${controlador}api/v1/casuality/contratistas/asignacionsuscriptor`,
  },

  endpointsV2: {
    catalogo: `${urlContratistas}catalogos`,
    guardarLead: `${urlContratistas}guardar-lead`,
    catalogo2: `${urlContratistas}catalogos-pantalla2`,
    guardarLead2: `${urlContratistas}guardar-pantalla2`,
    guardarTracking: `${urlBase}${controlador}api/v2/leads/save-tracking`,
    resumen: `${urlContratistas}resumen&XDEBUG_SESSION_START=name`,
    tarifacion: `${urlContratistas}tarifacion`,
    recargo: `${urlContratistas}recargos`,
    enviarCorreo: `${urlContratistas}enviarcotizacion`,
    catalogoContratante: `${urlPhp8}${controlador}api/v2/emision/catalogos-contratante`,
    generarPrepoliza: `${urlContratistas}generarprepoliza`,
    guardarContratante: `${urlPhp8}${controlador}api/v2/emision/guardar-contratante`,
    getUsuarioSuscriptor: `${urlContratistas}getusuariosuscriptor`,
    asignacionSuscriptor: `${urlContratistas}asignacionsuscriptor`,
  },

  suscriptorAccess: {
    leadPasoEquivalencia: true,
    seleccionPlanEquivalencia: true,
    resumenEquivalencia: true,
    contratanteEquivalencia: true,
    pagoEquivalencia: false,
  },
};
